module.exports = __webpack_public_path__ + "img/mono_6.c1d11d01.png";